import type { SVGProps } from "react";
import * as React from "react";

export function GreenQuote(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={14} height={10} fill="none" {...props}>
            <path
                fill="#20C997"
                d="M6.334 7.273c0 .773-.297 1.42-.892 1.943-.594.523-1.336.784-2.227.784-.87 0-1.624-.293-2.26-.878C.318 8.516 0 7.65 0 6.52c0-.668.138-1.337.414-2.006a9.108 9.108 0 0 1 1.05-1.88c.446-.586.923-1.108 1.432-1.568C3.406.606 3.894.25 4.36 0l1.592 1.536a3.6 3.6 0 0 0-.796.47c-.276.21-.53.45-.764.721-.233.251-.424.544-.573.878a2.18 2.18 0 0 0-.223.94c.786.105 1.433.398 1.942.878.53.46.796 1.076.796 1.85Zm7.666 0c0 .773-.297 1.42-.891 1.943-.594.523-1.337.784-2.228.784-.87 0-1.623-.293-2.26-.878-.636-.606-.955-1.473-.955-2.602 0-.668.138-1.337.414-2.006a9.108 9.108 0 0 1 1.05-1.88c.446-.586.923-1.108 1.433-1.568.509-.46.997-.815 1.464-1.066l1.591 1.536a3.6 3.6 0 0 0-.796.47c-.275.21-.53.45-.763.721-.234.251-.425.544-.573.878a2.179 2.179 0 0 0-.223.94c.785.105 1.432.398 1.941.878.53.46.796 1.076.796 1.85Z"
            />
        </svg>
    );
}
